module.exports = __webpack_public_path__ + "img/type2.ecf79bb3.png";